/**
 * Resolve subscription price from a listing/subscription document using a waterfall.
 * Different schemas / migrations have stored the cycle price under different keys:
 *   - data.base_plan_price (current schema, see subscriptionSchema.json)
 *   - data.monthlyPrice / data.monthly_price (legacy)
 *   - data.basePlanPrice (camelCase legacy)
 *   - data.unit_price / data.pricePerUnit (per-unit fallback for tiffin/milk)
 *   - top-level price (very old)
 *
 * Returns: number (0 if nothing resolvable). Pair with getSubscriptionPriceLabel()
 * for "/mo", "/wk", etc.
 */
export function getSubscriptionPrice(subscription) {
  if (!subscription) return 0;
  const d = subscription.data || {};
  const candidates = [
    d.base_plan_price,
    d.basePlanPrice,
    d.monthlyPrice,
    d.monthly_price,
    d.unit_price,
    d.pricePerUnit,
    d.price,
    subscription.price,
    subscription.aniyor_listing_price,
  ];
  for (const v of candidates) {
    if (v !== undefined && v !== null && v !== '' && !Number.isNaN(Number(v))) {
      const n = Number(v);
      if (n > 0) return n;
    }
  }
  return 0;
}

/**
 * Returns the per-cycle suffix label like "/mo", "/wk", "/qtr".
 */
export function getSubscriptionCycleSuffix(subscription) {
  const cycle = subscription?.data?.subscription_cycle || subscription?.data?.subscriptionCycle;
  switch (cycle) {
    case 'weekly': return '/wk';
    case '15_days': return '/15d';
    case 'monthly': return '/mo';
    case '2_months': return '/2mo';
    case '3_months': return '/qtr';
    case '6_months': return '/6mo';
    case 'yearly': return '/yr';
    case 'custom': return '';
    default: return '/mo';
  }
}

/**
 * Convenience: returns formatted "₹2,200/mo" or "₹N/A" if unresolved.
 */
export function formatSubscriptionPrice(subscription) {
  const price = getSubscriptionPrice(subscription);
  if (!price) return '₹N/A';
  const suffix = getSubscriptionCycleSuffix(subscription);
  return `₹${price.toLocaleString('en-IN')}${suffix}`;
}
